/** @fileoverview @suppress {undefinedVars} */

import * as exports from '../generators/dart.js';
$['__chunk_dart'] = exports;
